import React, { createRef } from "react";
import ProductCardQuickAdd from "./ProductCard.QuickAdd";
import * as gtmService from "../Services/Gtm.service";
import { translate } from "../Services/translation";
import FavoriteButton from '../Components/FavoriteButton';

const DEFAULT_BREAKPOINTS = {
    small: 6
};

export default product => {
    const breakpoints = product.columns || DEFAULT_BREAKPOINTS
    const productRef = createRef();

    const hide = property => typeof product.hide != 'undefined' && product.hide.find(p => p == property);

    // Function to check if we should show the specified product property
    const show = property => typeof product.show != 'undefined' ? product.show.find(p => p == property) : !hide(property);

    const onProductLinkClick = (e) => {
        const productUrl = e.target.href;
        if (!productUrl) return;

        e.preventDefault();

        gtmService.pushEcommerce({
            event: 'productClick',
            ecommerce: {
                currencyCode: gtmService.getCurrency(),
                click: {
                    products: [product.gtmProduct]
                }
            },
            eventCallback: () => {
                if (productUrl) {
                    window.location = productUrl
                }
            },
            eventTimeout: 100
        });
    }
    return <li ref={productRef} className={(product.className ? product.className + " " : "") + "product-list__item"}>
        <div className="product__wrapper">
            <figure className="product__figure">
                {product.imageUrls.length > 0
                    ? <a onClick={onProductLinkClick} href={product.url} className="product__image-link">
                        {product.imageUrls[0] && <img src={product.imageUrls[0]} className="product__image--first" />}
                        {product.imageUrls[1] && <img src={product.imageUrls[1]} className="product__image--secondary" />}
                    </a>
                    : <a onClick={onProductLinkClick} href={product.url} className="product__image-link">
                        <img src="https://via.placeholder.com/480x760/eee?text=Placeholder" className="product__image--first placeholder" />
                    </a>
                }
                <div className="product__favorite-button">
                    <FavoriteButton
                        item={product.id}
                        productData={{
                            productName: product.name,
                            brand: product.brand,
                            price: product.campaignPriceRaw || product.priceRaw,
                            imageUrl: product.imageUrls && product.imageUrls[0],
                            url: product.url
                        }}
                    />
                </div>
                {show("quick-add") && product.sizes.length > 0 &&
                    <div className="product__quick-add-container">
                        {<ProductCardQuickAdd sizeHint={product.sizeHint} sizeHintShort={product.sizeHintShort} sizeModels={product.sizes} shouldShowMiniCartOnAdd={product.shouldShowMiniCartOnAdd} />}
                    </div>
                }
            </figure>
            <article className="product__info">
                <div className="product__info--header">
                    <a onClick={onProductLinkClick} href={product.url} title={product.name}>
                        {show("brand") && <div>
                            {product.brand && <span className="product__brand">{product.brand}</span>}
                        </div>}
                        {show("name") && <h3 className="product__name">{product.name}</h3>}
                    </a>
                    {/* TODO Wishlist */}
                    {/* {show("wish-list") && <a className="product__info--favorite">
                        <i className="icon-star"></i>
                    </a>} */}
                </div>
                {show("price") && <div className="product__price">
                    {product.price && !product.campaignPrice && <span className="price">{product.price}</span>}
                    {product.campaignPrice && <>
                        <span className="product__campaign-price">
                            {product.campaignPrice}
                        </span>
                        <span className="product__old-price">
                            {product.price}
                        </span>
                        <span className="product__amount-off">
                            {product.discountPercent}
                        </span>
                    </>}
                    <link href={product.url} />
                </div>}
                {show("voucher-code") &&
                    <>
                        {product.voucherCode && product.voucherCode.discountPercent && product.voucherCode.code &&
                            <div class="product__usps">
                                <span class="product__usps--discount">{translate("product.voucher-code").replace("{0}", product.voucherCode.discountPercent)}&nbsp;<span class="product__usps--discount--amount">{product.voucherCode.code.toUpperCase()}</span></span>
                            </div>
                        }
                    </>
                }
            </article>
        </div>

    </li>
}